import { render, staticRenderFns } from "./JBProposalDisplayWindowAndShowcase.vue?vue&type=template&id=906c4cfe"
import script from "./JBProposalDisplayWindowAndShowcase.vue?vue&type=script&lang=js"
export * from "./JBProposalDisplayWindowAndShowcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports